import * as Sentry from '@sentry/browser';
import { showPreviewForbiddenFlash } from '@retailer/services/preview_forbidden_flash';

var httpConfig = function(C, $provide, $httpProvider) {
  const SKIP_LIST = {
    404: [
      /^\/api\/retailer\/saved_products\/save_entire_order$/,
      /^\/api\/retailer\/quick_order_lists\/\d+$/,
      /^\/api\/retailer\/cart\/submit$/,
      /^\/api\/retailer\/page_exists/,
      /^\/api\/retailer\/orders\/\d+$/,
      /^\/api\/retailer\/orders\/\d+\/discounts$/,
      /^\/api\/retailer\/order_groups\/\d+$/,
      /^\/api\/retailer\/discounts\/mix_and_match_by_order$/,
    ]
  };

  $provide.decorator('$http', ['$delegate', '$timeout', '$injector', '$window', function($delegate, $timeout, $injector, $window) {
    var $http = $delegate;
    var rootScope = $injector.get('$rootScope');
    var sendHttpErrorToSentry = function(e) {
      let errString = String(e.status) + ' ' + _.get(e, 'config.method') + ' - ' + _.get(e, 'config.url');

      if (window.RAILS_ENV == 'development') {
        console.log('In prod, would send HTTP error to sentry: ' + errString);
      }

      if (!C.SENTRY_URL) { return; }

      if (_.startsWith((window.location || {}).pathname, '/admin') && e.status == 404) {
        console.log('Note: not logging admin 404 to sentry');
        return;
      }

      if ((_.get(rootScope, 'trueUser.id') != _.get(rootScope, 'user.id')) && e.status == 404) {
        console.log('Note: not logging impersonated 404 to sentry');
        return;
      }

      let pathsToSkip = SKIP_LIST[e.status];
      if (pathsToSkip && pathsToSkip.some(path => path.test(_.get(e, 'config.url', '')))) {
        console.log('Note: not logging from skip list to sentry');
        return;
      }
      if (e.status === undefined) { return; }
      Sentry.withScope(scope => {
        scope.setExtra('context', window.sentryContext);
        let toSend = new Error(errString)
        toSend.name = errString;
        scope.setExtra('requestData', _.get(e, 'config.data'));
        Sentry.captureException(toSend);
      });
    };

    var wrapper = function() {
      var promise = $http.apply($http, arguments);

      var reqId = String(Math.random());

      if (window.RAILS_ENV == 'test') {
        pendingRequests[reqId] = JSON.stringify(arguments);
        console.log(`START ${arguments[0].method} ${arguments[0].url}`);
        promise.then(function(e) {
          delete(pendingRequests[reqId]);
          console.log("FINISH " + e.config.method + " " + e.config.url + " " + e.status);
        });
      }

      promise.catch(function(e) {
        if (window.RAILS_ENV == 'test') {
          console.log("FINISH ERROR " + JSON.stringify(arguments));
          delete(pendingRequests[reqId]);
          console.log(e.config.method + " " + e.config.url + " " + e.status);
        }
        if ((e || {}).status == 401) {
          window.FlashService.setMessage('You may not be logged in. Please <a href="/users/fully_log_out" onclick="window.location.href=\'/users/fully_log_out\'" class="dashed-underline underline-hover strong">log in</a> and try again or <a href="#hs-chat-open" class="dashed-underline underline-hover strong">chat with support right away</a>.', true);
        } else if ((e || {}).status == 403) {
          if ((rootScope.user || {}).role == 'supplier' && !$window.isChangingState) {
            showPreviewForbiddenFlash();
          }
        } else if (_.includes([-1, 422, 400, 403], (e || {}).status)) {
          console.log('Ignored aborted request');
        } else if ((e || {}).skipSentry) {
          // currently not working due to order of catch() calls
          console.log('Ignored aborted request');
        } else if ((e || {}).status == 500) {
          window.FlashService.setMessage('An unexpected error occurred. Please try again or <a href="#hs-chat-open" class="dashed-underline underline-hover strong">chat with support right away</a>.', true);
          sendHttpErrorToSentry(e)
        } else {
          sendHttpErrorToSentry(e)
        }
      });

      return promise;
    };

    Object.keys($http).filter(function (key) {
      return $http.hasOwnProperty(key);
    }).forEach(function (key) {
      if (typeof $http[key] == 'function') {
        wrapper[key] = function () {
          return $http[key].apply($http, arguments);
        };
      } else {
        wrapper[key] = $http[key];
      }
    });

    window.$http = $http; // for passing to svelte land

    return wrapper;
  }]);

  $httpProvider.defaults.paramSerializer = '$httpCustomSerializer';
}

export default httpConfig;
